import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

// Logo
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

// Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";


const Sidebar = ({ layoutType }) => {

  useEffect(() => {

    const verticalOverlay =
      document.querySelector(
        ".vertical-overlay"
      );

    if (!verticalOverlay) {
      return;
    }

    const handleOverlayClick = () => {
      document.body.classList.remove(
        "vertical-sidebar-enable"
      );
    };

    verticalOverlay.addEventListener(
      "click",
      handleOverlayClick
    );

    return () => {
      verticalOverlay.removeEventListener(
        "click",
        handleOverlayClick
      );
    };

  }, []);


  /* =========================================================
     DESKTOP SIDEBAR HOVER
  ========================================================= */

  const addEventListenerOnSmHoverMenu = () => {

    const currentSize =
      document.documentElement.getAttribute(
        "data-sidebar-size"
      );

    if (currentSize === "sm-hover") {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );

    } else if (
      currentSize === "sm-hover-active"
    ) {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover"
      );

    } else {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover"
      );

    }
  };


  /* =========================================================
     CLOSE MOBILE SIDEBAR
  ========================================================= */

 const closeMobileSidebar = () => {
  if (window.innerWidth <= 991) {
    document.body.classList.remove("vertical-sidebar-enable");
  }
};


  return (
    <React.Fragment>

      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <div className="app-menu navbar-menu">

        {/* ===================================================
            BRAND
        =================================================== */}

        <div className="navbar-brand-box">

          <Link
            to="/"
            className="logo logo-dark"
            onClick={
              closeMobileSidebar
            }
          >

            <span className="logo-sm">
              <img
                src={logoSm}
                alt="YatraNest"
                height="22"
              />
            </span>

            <span className="logo-lg">
              <img
                src={logoDark}
                alt="YatraNest"
                height="40"
              />
            </span>

          </Link>


          <Link
            to="/"
            className="logo logo-light"
            onClick={
              closeMobileSidebar
            }
          >

            <span className="logo-sm">
              <img
                src={logoSm}
                alt="YatraNest"
                height="22"
              />
            </span>

            <span className="logo-lg">
              <img
                src={logoLight}
                alt="YatraNest"
                height="17"
              />
            </span>

          </Link>


          {/* Desktop hover control */}

          <button
            onClick={
              addEventListenerOnSmHoverMenu
            }
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>

        </div>

        


        {/* ===================================================
            HORIZONTAL
        =================================================== */}

        {layoutType ===
        "horizontal" ? (

          <div id="scrollbar">

            <Container fluid>

              <div
                id="two-column-menu"
              ></div>

              <ul
                className="navbar-nav"
                id="navbar-nav"
                onClick={
                  closeMobileSidebar
                }
              >
                <VerticalLayout
                  layoutType={
                    layoutType
                  }
                />
              </ul>

            </Container>

          </div>

        ) : layoutType ===
          "twocolumn" ? (

          /* =================================================
             TWO COLUMN
          ================================================= */

          <React.Fragment>

            <div
              onClick={
                closeMobileSidebar
              }
            >
              <VerticalLayout
                layoutType={
                  layoutType
                }
              />
            </div>

            <div className="sidebar-background"></div>

          </React.Fragment>

        ) : (

          /* =================================================
             VERTICAL SIDEBAR
          ================================================= */

          <React.Fragment>

            <SimpleBar
              id="scrollbar"
              className="h-100"
            >

              <Container fluid>

                <div
                  id="two-column-menu"
                ></div>

                <ul
                  className="navbar-nav"
                  id="navbar-nav"
                  onClick={
                    closeMobileSidebar
                  }
                >

                  <VerticalLayout
                    layoutType={
                      layoutType
                    }
                  />

                </ul>

              </Container>

            </SimpleBar>


            <div className="sidebar-background"></div>

          </React.Fragment>

        )}

      </div>


      {/* =====================================================
          MOBILE OVERLAY
      ===================================================== */}

      <div className="vertical-overlay"></div>

    </React.Fragment>
  );
};


export default Sidebar;